import { MAX_INK_COLOR_NAME_LENGTH } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import type { RenameController } from '@/shared/lib';
import { Button, cn, InlineRenameForm, tableStyles } from '@/shared/ui';

interface InkColorRowInkColor {
  readonly id: string;
  readonly name: string;
  readonly colorCode: string;
}

interface InkColorRowProps {
  readonly inkColor: InkColorRowInkColor;
  readonly rename: RenameController;
  readonly onRenameStart: (inkColor: InkColorRowInkColor) => void;
  readonly onDelete: (inkColor: InkColorRowInkColor) => void;
}

/** 잉크 색상 표의 한 행 — 견본·이름(인라인 수정)·색상 코드·삭제. 색상 코드는 바꿀 수 없다. */
export const InkColorRow = ({
  inkColor,
  rename,
  onRenameStart,
  onDelete,
}: InkColorRowProps): ReactElement => {
  const isRenaming = rename.target?.id === inkColor.id;

  return (
    <tr className={tableStyles.row}>
      <td className={tableStyles.td}>
        {/* 테두리를 둬 흰색 계열 잉크도 보이게 한다. */}
        <span
          role="img"
          aria-label={`${inkColor.name} 견본`}
          className="block size-6 rounded-full border shadow-inner"
          style={{ backgroundColor: inkColor.colorCode }}
        />
      </td>
      <td className={cn(tableStyles.td, 'font-medium')}>
        {isRenaming && rename.target ? (
          <InlineRenameForm
            ariaLabel={`${inkColor.name} 새 이름`}
            name={rename.target.name}
            maxLength={MAX_INK_COLOR_NAME_LENGTH}
            isPending={rename.target.isPending}
            onNameChange={rename.onChange}
            onSubmit={rename.onSubmit}
            onCancel={rename.onCancel}
          />
        ) : (
          inkColor.name
        )}
      </td>
      <td className={cn(tableStyles.td, 'font-mono text-muted-foreground')}>
        {inkColor.colorCode}
      </td>
      <td className={tableStyles.td}>
        <span className="flex items-center gap-1">
          {isRenaming ? null : (
            <Button variant="ghost" size="sm" onClick={() => onRenameStart(inkColor)}>
              수정
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            className="text-destructive"
            aria-label={`${inkColor.name} 삭제`}
            onClick={() => onDelete(inkColor)}
          >
            삭제
          </Button>
        </span>
      </td>
    </tr>
  );
};
